/**
 * 创建人：张丽莉
 * 描述：该组件为自定义文物车组件
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $: any;
@Component({
  selector: 'sw-sonline',
  templateUrl: './sw-sonline.component.html',
  styleUrls: ['./sw-sonline.component.css']
})
export class SwSonlineComponent implements OnInit {
  /**
   * left或right (定位到浏览器左边还是右边)
   */
  @Input() position: string = "right"; 
  /**
   * 顶部距离，默认140px
   */
  @Input() top: number = 140;
   /**
   * 默认展开：true,默认收缩：false
   */
  @Input() defaultsOpen: boolean = false; 
   /**
   * 获取随机id
   */
  idt: string;
   /**
   * 数据 , 比如格式类型：[{ClassifyID: "002",ClassifyType: 5,Guid: "45065e90e9f8403fac5851f4636eb06b",ID: 1605,McrName: "文物2"}]
   */
  @Input() datas: any = []; 

  /**
   * 列表总记录数
   */
  @Input() datasCount:number = 0;

  /**
   * 数据title,比如格式类型：[{descript: '分类号',name: 'ClassifyID'},{descript: '名称',name: 'McrName'}]
   */
  @Input() datasTitle: any = [];
  /**
   * 展示的名称
   */
  @Input() lineTitle: string = ""; 
  /**
   * 抛出选择的事件或'更多'事件 查看详情
   */
  @Output() outClickView = new EventEmitter();
  constructor(
  ) { }

  ngOnInit() {
  /**
   *  获取随机id
   */
    this.idt = "SonlineBox" + Math.random().toString().split(".")[1];
  }
  /**
   *  打开自定义部分
   */
  openTrigger() {
    let widthValue =  $("#" + this.idt + "> .contentBox ").width();
    if (this.position == "left") {  $("#" + this.idt + "> .contentBox ").animate({ left: 0 }, "fast"); }
    else if (this.position == "right") {  $("#" + this.idt + "> .contentBox ").animate({ right: 0 }, "fast"); }
    $("#"+this.idt).css({ width: widthValue + 6 });
    $("#" + this.idt + "> .openTrigger ").hide();
  }
 /**
   *  关闭自定义部分
   */
  closeTrigger() {
    $("#" + this.idt + "> .openTrigger").show();
    var widthValue = 30;
    var allWidth = (-($("#" + this.idt + "> .contentBox ").width()) - 6);
    if (this.position == "left") { $("#" + this.idt + "> .contentBox ").animate({ left: allWidth }, "fast"); }
    else if (this.position == "right") { $("#" + this.idt + "> .contentBox ").animate({ right: allWidth }, "fast"); }
    $("#"+this.idt).animate({ width: widthValue }, "fast");
  }
  ngAfterViewInit(): void {
     //如果默认打开方式为： 默认展开
     if(this.defaultsOpen){
       this.openTrigger()
     }
  }

 //点击更多或列表查看详情
 clickView(){
    this.outClickView.emit(this.datas)
 }












}

